/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditNoteRequest
 */
export interface EditNoteRequest {
  /**
   *
   * @type {string}
   * @memberof EditNoteRequest
   */
  noteId: string;
  /**
   *
   * @type {string}
   * @memberof EditNoteRequest
   */
  body: string;
}

/**
 * Check if a given object implements the EditNoteRequest interface.
 */
export function instanceOfEditNoteRequest(
  value: object,
): value is EditNoteRequest {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function EditNoteRequestFromJSON(json: any): EditNoteRequest {
  return EditNoteRequestFromJSONTyped(json, false);
}

export function EditNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
    body: json["body"],
  };
}

export function EditNoteRequestToJSON(json: any): EditNoteRequest {
  return EditNoteRequestToJSONTyped(json, false);
}

export function EditNoteRequestToJSONTyped(
  value?: EditNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
    body: value["body"],
  };
}
